













































































import { Component, Vue } from "vue-property-decorator";
import {
  Image as VanImage,
  Skeleton,
  List,
  Toast,
  PullRefresh,
  Button as VanButton
} from "vant";
import { IChatRoomItem } from "@/api/types";
import req from "@/api/portrait";

@Component({
  components: {
    VanImage,
    List,
    Skeleton,
    PullRefresh,
    VanButton
  }
})
export default class ChatComment extends Vue {
  // 渲染的数据
  chatRoomList: IChatRoomItem[] = [];
  // 列表下拉刷新
  refreshing = false;
  // 列表加载动画
  loading = true;
  finish = false;

  chatPage = {
    lastCreateTime: "",
    lastReplyId: ""
  };

  mounted() {
    this.getChatRoom();
  }

  initData() {
    this.chatRoomList = [];
    this.finish = false;
    this.chatPage = {
      lastCreateTime: "",
      lastReplyId: ""
    };
  }

  // 获取聊天室数据
  async getChatRoom() {
    return req
      .getChatRoom({
        infoClassifyId: this.$route.query.id as string,
        ...this.chatPage
      })
      .then(res => {
        if (res.code === 0) {
          this.chatRoomList.push(...(res.data || []));
          if (!!res.data && res.data.length) {
            const last = res.data[0];
            this.chatPage.lastReplyId = last.id + "";
            this.chatPage.lastCreateTime = last.createTime;
          }
          if (res.data.length < 10) {
            this.finish = true;
          } else {
            this.finish = false;
          }
        } else {
          Toast.fail(res.message);
        }
      })
      .catch(err => {
        console.warn(err);
        Toast.fail("获取聊天室信息失败！");
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onLoad() {
    this.getChatRoom();
  }

  onRefresh() {
    setTimeout(async () => {
      this.initData();
      await this.getChatRoom();
      this.refreshing = false;
    }, 1000);
  }
}
